import * as Yup from 'yup';

export const AcceptWithdraw = Yup.object().shape({
    transaction_number: Yup.string().required("Transaction number is required"),
    user_account_details: Yup.string().required("user account detail is required"),
    admin_account_details: Yup.string().required("Admin account detail is required"),
    transaction_medium: Yup.string().required("Transaction medium is required"),
    utr_number: Yup.string().required("UTR number is required"),
  });